/* eslint-disable no-param-reassign */
export default (str, length, ending) => {
  if (!str) return '';
  if (!length) length = 100;
  if (!ending) ending = '...';
  return str.length > length ? str.substring(0, length - ending.length) + ending : str;
};
